var map = {
	"./breakout_space.png": "5ca3",
	"./cat_5E_cabling.png": "eb73",
	"./cleaning_service.png": "ba2e",
	"./electric_car_charging.png": "5c42",
	"./free_car_parking.png": "c927",
	"./garden_picnic_area.png": "2bcf",
	"./hi_speed_broadband_wifi.png": "760d",
	"./hot_beverages_provided.png": "466c",
	"./on_site_gym.png": "9e4b",
	"./utilities_included.png": "d5a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2de2";